// removed by extract-text-webpack-plugin
module.exports = {"Modal":"src-components-contact----modal-module---Modal---1Jgo6","Modal__heading":"src-components-contact----modal-module---Modal__heading---32dhb","Modal__close":"src-components-contact----modal-module---Modal__close---3m3ad","Modal__body":"src-components-contact----modal-module---Modal__body---QkJvs","spinAround":"src-components-contact----modal-module---spinAround---34-Kq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/modal.module.scss
// module id = 213
// module chunks = 114276838955818 184470312924441